import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  withIcon?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  withIcon = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-300 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-bright-teal hover:bg-deep-teal text-white shadow-lg hover:shadow-xl focus:ring-bright-teal',
    secondary: 'bg-sunset-orange hover:bg-golden-orange text-white shadow-lg hover:shadow-xl focus:ring-sunset-orange',
    outline: 'border-2 border-warm-brown text-warm-brown hover:bg-warm-brown hover:text-white'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-301">
      {children}
      {withIcon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-302" />}
    </motion.button>;
}